import TicketDetailsDescriptionTemplates from './TicketDetailsDescriptionTemplates';

export default TicketDetailsDescriptionTemplates;
